iScreenWizard.factory('Dictionary', function ($http, $rootScope) {

    var data = {},
        baseUrl = '/translate';

    data.capitalize = function(translation, capitalize) {
        if (typeof translation !== 'undefined' && capitalize) {
            translation = translation.charAt(0).toUpperCase() + translation.slice(1);
        }
        return translation;
    };

    var recompose = function (obj, string){
        var parts = string.split('.');
        var newObj = obj[parts[0]];
        if(parts[1]){
            parts.splice(0,1);
            var newString = parts.join('.');
            return recompose(newObj,newString);
        }
        return newObj;
    };

    var decodeEntities = (function() {
        // this prevents any overhead from creating the object each time
        var element = document.createElement('div');

        function decodeHTMLEntities (str) {
            if(str && typeof str === 'string') {
                // strip script/html tags
                str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
                str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
                element.innerHTML = str;
                str = element.textContent;
                element.textContent = '';
            }

            return str;
        }

        return decodeHTMLEntities;
    })();

    data.translate = function (source, capitalize, replacements) {
        translation = recompose(window.trans, source);
        translation = decodeEntities(translation);
        angular.forEach(replacements, function(replacementValue, replacementKey) {
            translation = translation.replace(':'+replacementKey, replacementValue);
        });
        return data.capitalize(translation, capitalize);
    };

    return data;
});